import type { TemplateOnlyComponent } from '@ember/component/template-only';

export interface Signature {
  Args: {
    class?: string;
  };
  Element: SVGElement;
}

const WrSettingsIconComponent: TemplateOnlyComponent<Signature> = <template>
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='16'
    height='16'
    viewBox='0 0 16 16'
    fill='none'
    class={{@class}}
    ...attributes
  >
    <path
      d='M6 6.7V3.7C6 3.4 6.3 3 6.7 3C7.1 3 7.4 3.3 7.4 3.7V4.5H13.7C14.1 4.5 14.4 4.8 14.4 5.2C14.4 5.6 14.1 5.9 13.7 5.9H7.4V6.7C7.4 7.1 7.1 7.4 6.7 7.4C6.3 7.4 6 7.1 6 6.7ZM2.7 5.9H4.7C5.1 5.9 5.4 5.6 5.4 5.2C5.4 4.8 5.1 4.5 4.7 4.5H2.7C2.3 4.5 2 4.8 2 5.2C2 5.6 2.3 5.9 2.7 5.9ZM8.7 10H2.7C2.3 10 2 10.3 2 10.7C2 11.1 2.3 11.4 2.7 11.4H8.7C9.1 11.4 9.4 11.1 9.4 10.7C9.4 10.3 9.1 10 8.7 10ZM13.7 10H11.4V9.2C11.4 8.8 11.1 8.5 10.7 8.5C10.3 8.5 10 8.9 10 9.2V12.2C10 12.6 10.3 12.9 10.7 12.9C11.1 12.9 11.4 12.6 11.4 12.2V11.4H13.7C14.1 11.4 14.4 11.1 14.4 10.7C14.4 10.3 14.1 10 13.7 10Z'
      fill='currentColor'
    />
  </svg>
</template>;

export default WrSettingsIconComponent;
